import { X, AlertTriangle } from 'lucide-react';

/**
 * Shared emergency-lockdown confirmation modal (desktop Home + MobileHome).
 * Markup lifted verbatim from Home so styling is unchanged.
 */
export default function LockdownConfirmModal({ show, isLockedDown, loading, onConfirm, onCancel }) {
  if (!show) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content lockdown-modal">
        <button className="modal-close" onClick={onCancel}>
          <X size={24} />
        </button>
        <div className="modal-icon">
          <AlertTriangle size={48} color={isLockedDown ? 'var(--status-ok)' : 'var(--status-warn)'} />
        </div>
        <h2>{isLockedDown ? 'Release Lockdown?' : 'Confirm Lockdown'}</h2>
        <p>
          {isLockedDown
            ? 'This will release the lockdown and restore normal door operations.'
            : 'This will immediately lock ALL doors in the facility. This action should only be used in emergencies.'}
        </p>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button
            className={`btn ${isLockedDown ? 'btn-success' : 'btn-danger'}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : (isLockedDown ? 'Release Lockdown' : 'Confirm Lockdown')}
          </button>
        </div>
      </div>
    </div>
  );
}
